<template>
  <div>
    <input type="checkbox" id="check" />
    <!--header area start-->
    <header>
      <label for="check">
        <i class="fas fa-bars" id="sidebar_btn"></i>
      </label>
      <div class="left_area">
        <h3>Expar <span>STORE</span></h3>
      </div>
      <div class="right_area">
        <a href="./" class="logout_btn" @click="logout">Logout</a>
      </div>
    </header>
    <!--header area end-->
    <!--mobile navigation bar start-->
    <div class="mobile_nav">
      <div class="nav_bar">
        <img
          src="../assets/static/images/shr_logo.png"
          class="mobile_profile_image"
          alt=""
        />
        <i class="fa fa-bars nav_btn" @click="isActive = !isActive"></i>
      </div>
      <div class="mobile_nav_items" v-bind:class="{ active: isActive }">
        <router-link :to="{ name: 'supportProfile' }"
          ><font-awesome-icon icon="address-card" /><span
            >Profile</span
          ></router-link
        >
        <router-link :to="{ name: 'ticket-list' }"
          ><font-awesome-icon icon="ticket-alt" /><span
            >Tickets</span
          ></router-link
        >
        <router-link :to="{ name: 'metricsSupport' }"
          ><font-awesome-icon icon="tachometer-alt" /><span
            >Metrics</span
          ></router-link
        >
        <router-link :to="{ name: 'settingsSupport' }"
          ><font-awesome-icon icon="cogs" /><span>Settings</span></router-link
        >
      </div>
    </div>
    <!--mobile navigation bar end-->
    <!--sidebar start-->
    <div class="sidebar">
      <router-link :to="{ name: 'supportPanel' }" class="no-hover">
        <div class="profile_info">
          <img
            src="../assets/static/images/shr_logo.png"
            class="profile_image"
            alt=""
          />
          <h4>{{ client.client.name }}</h4>
        </div>
      </router-link>
      <router-link :to="{ name: 'supportProfile' }"
        ><font-awesome-icon class="icon" icon="address-card" /><span
          style="margin-left: 15px; font-size: 1.5em"
          >Profile</span
        ></router-link
      >
      <router-link :to="{ name: 'ticket-list' }"
        ><font-awesome-icon class="icon" icon="ticket-alt" /><span
          style="margin-left: 15px; font-size: 1.5em"
          >Tickets</span
        ></router-link
      >
      <router-link :to="{ name: 'metricsSupport' }"
        ><font-awesome-icon class="icon" icon="tachometer-alt" /><span
          style="margin-left: 15px; font-size: 1.5em"
          >Metrics</span
        ></router-link
      >
      <router-link :to="{ name: 'settingsSupport' }"
        ><font-awesome-icon class="icon" icon="cogs" /><span
          style="margin-left: 15px; font-size: 1.5em"
          >Settings</span
        ></router-link
      >
    </div>
    <!--sidebar end-->
    <div class="content">
      <div class="card">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      isActive: false
    }
  },
  computed: mapState(['client']),
  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="css" scoped>
body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
}

header {
  z-index: 1;
  position: fixed;
  background: var(--bg);
  padding: 20px;
  width: calc(100% - 0%);
  top: 0;
  height: 70px;
}

.left_area h3 {
  color: var(--white);
  margin: -10px;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 900;
}

.left_area span {
  color: var(--white);
}

.logout_btn {
  padding: 5px;
  background: var(--bg-light);
  text-decoration: none;
  float: right;
  margin-top: -30px;
  margin-right: 20px;
  border-radius: 2px;
  font-size: 15px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  transition-property: background;
}

.logout_btn:hover {
  background: #49535e;
}

.sidebar {
  z-index: 1;
  top: 0;
  background: var(--bg-light);
  margin-top: 70px;
  padding-top: 30px;
  position: fixed;
  left: 0;
  width: 250px;
  height: calc(100% - 9%);
  transition: 0.5s;
  transition-property: left;
  overflow-y: auto;
}

.profile_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sidebar .profile_info .profile_image {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  margin-bottom: 10px;
}

.sidebar .profile_info h4 {
  color: var(--white);
  margin-top: 0;
  margin-bottom: 50px;
  font-size: 1.2rem;
}

.sidebar a {
  color: var(--white);
  text-align: left;
  display: block;
  width: 100%;
  line-height: 60px;
  text-decoration: none;
  padding-left: 40px;
  box-sizing: border-box;
  transition: 0.5s;
  transition-property: background;
}

.sidebar a:hover {
  background: var(--bg);
}

.sidebar .no-hover:hover {
  background: var(--bg-light);
}

.sidebar .icon {
  /* padding-right: 10px; */
  font-size: 2em;
}

label #sidebar_btn {
  z-index: 1;
  color: var(--white);
  position: fixed;
  cursor: pointer;
  left: 20px;
  font-size: 30px;
  margin: 5px 0;
  transition: 0.5s;
  transition-property: color;
}

label #sidebar_btn:hover {
  background: var(--bg);
}

#check:checked ~ .sidebar {
  left: -185px;
}

#check:checked ~ .sidebar a span {
  display: none;
}

#check:checked ~ .sidebar a {
  font-size: 10px;
  margin-left: 165px;
  width: 100%;
}

.content {
  width: (100% - 250px);
  margin-top: 60px;
  padding: 20px;
  margin-left: 250px;
  background: url('../assets/static/images/bg.jpg');
  background-repeat: repeat-y;
  background-position: center;
  background-size: cover;
  height: 100vh;
  transition: 0.5s;
  z-index: -1;
}

#check:checked ~ .content {
  margin-left: 60px;
}

#check:checked ~ .sidebar .profile_info {
  display: none;
}

#check {
  display: none;
}

.mobile_nav {
  display: none;
}

.left_area h3 {
  font-weight: 600;
  color: var(--white);
}
.left_area span {
  font-weight: 100;
  color: var(--primary);
}

/* Responsive CSS */

@media screen and (max-width: 780px) {
  .sidebar {
    display: none;
  }

  #sidebar_btn {
    display: none;
  }

  .content {
    margin-left: 0;
    margin-top: 0;
    padding: 10px 20px;
    transition: 0s;
    background-repeat: repeat-y !important;
  }

  #check:checked ~ .content {
    margin-left: 0;
  }

  .mobile_nav {
    display: block;
    width: calc(100% - 0%);
  }

  .nav_bar {
    background: var(--bg);
    width: (100% - 0px);
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  }

  .nav_bar .mobile_profile_image {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .nav_bar .nav_btn {
    color: var(--white);
    font-size: 22px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: color;
  }

  .nav_bar .nav_btn:hover {
    background: var(--bg);
  }

  .mobile_nav_items {
    background: var(--bg-light) !important;
    display: none;
  }

  .mobile_nav_items a {
    color: var(--white);
    display: block;
    text-align: center;
    letter-spacing: 1px;
    line-height: 60px;
    text-decoration: none;
    box-sizing: border-box;
    transition: 0.5s;
    transition-property: background;
  }
  .mobile_nav_items a:hover {
    background: var(--bg);
  }
  .mobile_nav_items .icon {
    padding-right: 10px;
    font-size: 1.4em;
  }
  .mobile_nav_items span {
    padding-left: 10px;
    font-size: 1.4em;
  }
  .logout_btn {
    margin-right: 0px;
  }
  .active {
    display: block;
  }
}
</style>
